export const extendUrlFulfillment = {
    url: process.env.REACT_APP_URL_FFM || "https://fulfillment-staging.merchize.com"
}
